var exports = {
  "Text": "Text__jrFZx9",
  "Box": "Box__eLPxOz",
  "success": "success__h99Gtp",
  "error": "error__9f9X_r",
  "warning": "warning___Slu2U",
};

__webpack_require__.r(module.exports = exports);
